import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../servicios/api/api.service';
import { fuenteI } from '../../modelos/fuentes.interface';
import { DeptoI } from '../../modelos/departamento.interface';
import { MuniI } from '../../modelos/municipio.interface';
import { DireccionNor } from '../../modelos/direccionNor';
import { FormControl, Validators } from '@angular/forms';
import { LoginI } from 'src/app/modelos/login.interface';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { DireccionI } from 'src/app/modelos/direccion';
import { DivipolaI } from 'src/app/modelos/Divipola';

@Component({
  selector: 'app-caratula',
  templateUrl: './caratula.component.html',
  styleUrls: ['./caratula.component.css']
})
export class CaratulaComponent implements OnInit, AfterViewInit {

  fuenteUsu : fuenteI;
  DireccionNormalizada : DireccionNor;
  Departamentos : DivipolaI[];
  Municipios : DivipolaI[];
  deptoFte : DeptoI;
  muniFte : DivipolaI;

  nombreUsuario : String;
  auxDepto : Number;
  auxMuni : Number;
  DireccionFinal : string;
  btnguardar: Boolean;
  continuar : Boolean;

  DireccionForm = {
    Via : "",
    NumNomVia : "",
    AcoNome : "",
    Prefijo : "",
    CuadranteUno : "",
    Numeral : "#",
    NumPrefijoUno : "",
    LetraPrefijo : "",
    NumPrefijoDos : "",
    CuadranteDos : "",
    CompleDirec : "",
    NumLetComp : ""
  }

  DireccionPrueba : DireccionI;

  UsuarioFuente : UsuarioI;
  ContrasenaActual : string;
  ContrasenaNueva : string;
  ContrasenaConfirma : string;
  BtnCambiar : Boolean;

  ProbLog : LoginI;

  PasswordNew = new FormControl('',[Validators.required, Validators.minLength(8),
    Validators.pattern(/^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,16}$/)]);

    @ViewChild('openModalRecuContraseña') openModalRecuContraseña: ElementRef;
    @ViewChild('closeModalRecuContraseña') closeModalRecuContraseña: ElementRef;
    @ViewChild('closeModalDireccion') closeModalDireccion: ElementRef;

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.DireccionPrueba = new DireccionI;
    this.fuenteUsu = new fuenteI;
    this.UsuarioFuente = new UsuarioI;
    //this.deptoFte = new DeptoI;
    this.muniFte = new DivipolaI;
    this.nombreUsuario = localStorage.getItem('usuario');
    this.api.getUsuarioByUsername(this.nombreUsuario).subscribe(Usuario=>{
      //console.log(Usuario);
      this.UsuarioFuente = Usuario;
      localStorage.setItem("idFte",Usuario.fuente.toString());
      this.api.getFuenteById(Usuario.fuente).subscribe(Fuente=>{
        this.fuenteUsu = Fuente;
        //console.log(this.fuenteUsu);
        this.verificarCambioContraseña();
        this.api.getDireccionFuente(this.fuenteUsu.id).subscribe(direcc=>{
          this.DireccionPrueba = direcc;
          //console.log(this.DireccionPrueba);
        },error=>{
          console.log(error);
        });
        this.api.getMuniByCodigo(this.fuenteUsu.muni).subscribe(resp1=>{
          this.muniFte = resp1;
        });
      },error=>{
        console.log(error);
      });
    },error=>{
      console.log(error);
    });
    this.api.getDeptos().subscribe(data=>{
      this.Departamentos = data;
    },error=>{
      console.log(error);
    });
    /*this.api.getdeptoByCod(this.fuenteUsu.depto).subscribe(rest0=>{
      this.deptoFte = rest0;
    });*/
  }

  ngAfterViewInit(){
  }

  getMunicByDepto(cod){
    this.fuenteUsu.depto = cod;
    this.api.getMuniByDepto(cod).subscribe(data=>{
      this.Municipios = data;
    },error=>{
      console.log(error);
    });
    /*this.api.getdeptoByCod(cod).subscribe(data=>{
      this.fuenteUsu.depto = data.codigo;
    },error=>{
      console.log(error);
    });*/
  }

  setMunici(codmuni){
    this.fuenteUsu.muni = codmuni;
    /*this.api.getMuniById(id).subscribe(data=>{
      this.fuenteUsu.muni = data.codigo;
    },error=>{
      console.log(error);
    });*/
  }

  verificarCambioContraseña(){
    if (this.UsuarioFuente.nuevaClave) this.openModalRecuContraseña.nativeElement.click();
  }

  guardarFuente(){
    this.btnguardar = false;
    this.continuar = true;
    if (this.fuenteUsu.nombEntidad == "" || this.fuenteUsu.nombEntidad == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar razón social.', 'Advertencia!');
    } else if (this.fuenteUsu.direccion == "" || this.fuenteUsu.direccion == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar dirección.', 'Advertencia!');
    } else if (this.fuenteUsu.nit == "" || this.fuenteUsu.nit == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar NIT.', 'Advertencia!');
    } else if (this.fuenteUsu.nombresp == "" || this.fuenteUsu.nombresp == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombre del responsable.', 'Advertencia!');
    } else if (this.fuenteUsu.cargoresp == "" || this.fuenteUsu.cargoresp == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo del responsable.', 'Advertencia!');
    } else if (this.fuenteUsu.telresp == "" || this.fuenteUsu.telresp == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar telefono del responsable.', 'Advertencia!');
    } else if (this.fuenteUsu.email == "" || this.fuenteUsu.email == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo del responsable.', 'Advertencia!');
    } else {
      if (this.continuar){
        this.btnguardar = true;
        this.api.guardarFuenteEditadaDesdeCaratula(this.fuenteUsu).subscribe(data=>{
          if(data){
            localStorage.setItem("caratulaOk","0");
            this.toastr.success('Información guardada.', 'OK!');
            if (localStorage.getItem('tipo') == "CHV"){
              this.router.navigate(['carguemasivo']);
            } else if (localStorage.getItem('tipo') == "FIVI") {
              this.router.navigate(['carguemasivofivi']);
            }
          }
        },error=>{
          console.log(error);
        });
      }
    }
  }

  NormalizandoDirecccion(){
    if (this.DireccionPrueba.tipovia == null){
      this.DireccionPrueba.tipovia = "";
    }
    if (this.DireccionPrueba.letravia == null){
      this.DireccionPrueba.letravia = "";
    }
    if (this.DireccionPrueba.prefijo == null){
      this.DireccionPrueba.prefijo = "";
    }
    if (this.DireccionPrueba.cuaduno == null){
      this.DireccionPrueba.cuaduno = "";
    }
    if (this.DireccionPrueba.letpre == null){
      this.DireccionPrueba.letpre = "";
    }
    if (this.DireccionPrueba.cuaddos == null){
      this.DireccionPrueba.cuaddos = "";
    }
    if (this.DireccionPrueba.complemento == null){
      this.DireccionPrueba.complemento = "";
    }
    if (this.DireccionPrueba.acomple == null){
      this.DireccionPrueba.acomple = "";
    }
  }

  Complemento(){
    this.DireccionPrueba.acomple = this.DireccionPrueba.acomple + " " + this.DireccionPrueba.complemento + " ";
  }

  normalizarDireccion(){
    this.DireccionPrueba.complemento = "";
    this.DireccionFinal = this.DireccionPrueba.tipovia + ' ' + this.DireccionPrueba.numvia + ' ' + this.DireccionPrueba.letravia + ' ' +
    this.DireccionPrueba.prefijo + ' ' + this.DireccionPrueba.cuaduno + ' # ' + this.DireccionPrueba.numpreuno + ' ' + this.DireccionPrueba.letpre + ' ' +
    this.DireccionPrueba.numpredos + ' ' + this.DireccionPrueba.cuaddos + ' ' + this.DireccionPrueba.acomple;
    //console.log(this.DireccionPrueba);
    //console.log(this.DireccionFinal);
    this.fuenteUsu.direccion = this.DireccionFinal;

    this.api.guardarDireccionFuente(this.DireccionPrueba).subscribe(result=>{
      //console.log(result);
    },error=>{
      console.log(error);
    });

    this.closeModalDireccion.nativeElement.click();
  }

  recuperarContrasena(){
    this.openModalRecuContraseña.nativeElement.click();
  }

  enviarCorreo(){
    this.closeModalRecuContraseña.nativeElement.click();


  }

}
